import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OauthService } from '../services/oauth.service';
import { ToastService } from '../services/toast.service';

/**
 * Gate developer/admin-only areas — the trace views (#306, studio #65) and
 * user role management (#314): only the backend `admin` role may enter (the
 * server enforces the same, so this is UX, not security). Non-admins are
 * sent back to the studies workspace.
 */
export const traceAccessGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const auth = inject(OauthService);
  const toastService = inject(ToastService);

  const user = await auth.getUser();

  if (!user) {
    router.navigate(['/']);
    return false;
  }

  if (user.role !== 'admin') {
    toastService.showError('This area requires developer (admin) access');
    router.navigate(['/sdtm']);
    return false;
  }
  return true;
};
